import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Watch = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg",
    "stroke": "currentColor",
    "strokeLinecap": "round",
    "strokeLinejoin": "round"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    key: "k0"
  }), React.createElement("polyline", {
    points: "12 9 12 12 13.5 13.5",
    key: "k1"
  }), React.createElement("path", {
    d: "M16.51 17.35l-.35 3.83a2 2 0 01-2 1.82H9.83a2 2 0 01-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 019.83 1h4.35a2 2 0 012 1.82l.35 3.83",
    key: "k2"
  }));
});
Watch.displayName = 'Watch';
export var WatchDimensions = {
  height: 24,
  width: 24
};